export default "__VITE_ASSET__DMSFLXTu__"